import { createAppAsyncThunk } from '@/domain/store.thunk';

export const signInStep1AskUserToLogin = createAppAsyncThunk(
  'auth/signInStep1AskUserToLogin',
  async (_, { extra: { authGateway } }) => {
    authGateway.startSignInProcess();
  },
);
